import makeStyles from '@material-ui/core/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { color } from '../../../app/theme';

const useStyles = makeStyles(
  () => ({
    content: ({ width }) => ({
      width: width || 204,
      fontSize: 13,
      color: color.$13,
      backgroundColor: color.$7,
      boxShadow:
        '0 16px 48px 0 rgba(0, 0, 0, 0.07), 0 6px 18px 0 rgba(0, 0, 0, 0.03)',
      borderRadius: 12,
      '& > hr': {
        backgroundColor: color.$9,
        opacity: 0.6,
        margin: 0,
      },
    }),
    title: {
      fontSize: 13,
      lineHeight: 'normal',
      color: color.$11,
      padding: 16,
      wordWrap: 'break-word',
      whiteSpace: 'pre-wrap',
    },
    action: {
      cursor: 'pointer',
      display: '-webkit-inline-box',
      width: '50%',
      fontSize: 13,
      textAlign: 'center',
      color: color.$2,
      overflow: 'hidden',
      '-webkit-box-orient': 'vertical',
      '-webkit-line-clamp': 2,
      'word-wrap': 'break-word',
      textOverflow: 'ellipsis',
      padding: '0px 16px',
      margin: '9px 0px',
    },
    textColor: {
      color: color.$2,
    },
  }),
  { name: 'ConfirmCard' },
);

function ConfirmCard({ elements, width }) {
  const classes = useStyles({ width });
  const { t } = useTranslation();
  let action1 = null;
  let action2 = null;

  if (elements?.[0]?.buttons[0]?.type === 'url') {
    action1 = (
      <a
        className={classes.textColor}
        href={elements?.[0]?.buttons[0]?.data || '#'}
        target="_blank"
        rel="noopener noreferrer"
      >
        {elements?.[0]?.buttons[0]?.title || t('title')}
      </a>
    );
  } else {
    action1 = elements?.[0]?.buttons[0]?.title || t('title');
  }

  if (elements?.[0]?.buttons[1]?.type === 'url') {
    action2 = (
      <a
        className={classes.textColor}
        href={elements?.[0]?.buttons[1]?.data || '#'}
        target="_blank"
        rel="noopener noreferrer"
      >
        {elements?.[0]?.buttons[1]?.title || t('title')}
      </a>
    );
  } else {
    action2 = elements?.[0]?.buttons[1]?.title || t('title');
  }

  return (
    <div className={classes.content}>
      <div className={classes.title}>{elements?.[0]?.title || t('title')}</div>
      <hr />
      <div className={classes.confirmContainer}>
        <div className={classes.action}>{action1}</div>
        <div className={classes.action}>{action2}</div>
      </div>
    </div>
  );
}

export default ConfirmCard;
